import { Box, BoxProps } from "@chakra-ui/react";
import { FiChevronRight } from "react-icons/fi";

export const ChevronRight = (props: BoxProps) => {
  return <Box as={FiChevronRight} height="20px" width="20px" {...props} />;
};
